import * as Yup from "yup";
import { FORM_ERROR_MESSAGES } from "@shared/constants";

export const createValidationSchema = Yup.object().shape({
  file: Yup.string().required(FORM_ERROR_MESSAGES.REQUIRED).nullable(),
});

export const getInitValues = () => {
  return {
    file: "",
  };
};
